import Typography from '@material-ui/core/Typography'
import { styled } from '@material-ui/core'

export const StyledTypography = styled(Typography)(() => ({
  padding: '10px'
}))
